<template>
  <div style="margin-top:-10px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
        style="height:42px"
      >
        <!-- <b-col m5="1"></b-col> -->
        <b-col cols="4" md="4" xl="4" lg="4" sm="4" xs="4" class="text-left px-0">
          <!--  invoice header details -->
          <!--  invoice no and status name -->
          <h2 class="custom-page-title mb-2 mt-1">
            {{ list.invoice_header_detail.inv_no }}
            <small
              class="pl-2"
              v-if="
                $route.query.page_from == 'quot_view' ||
                  $route.query.page_from == 'credit_view' ||
                  $route.query.page_from == 'amc_contract' ||
                  $route.query.page_from == 'recurring'
              "
            >
              <router-link
                :to="{
                  name:
                    $route.query.page_from == 'quot_view'
                      ? 'SalesView'
                      : $route.query.page_from == 'amc_contract'
                      ? 'AmcContractView'
                      : $route.query.page_from == 'recurring'
                      ? 'RecurringInvoiceView'
                      : 'CreditView',
                  params: { id: $route.query.id },
                }"
              >
                <span
                  class="text-link"
                  v-b-tooltip
                  :title="
                    $route.query.page_from == 'quot_view'
                      ? 'Quotation'
                      : $route.query.page_from == 'amc_contract'
                      ? 'Amc contract'
                      : $route.query.page_from == 'recurring'
                      ? 'Recurring invoive'
                      : 'Credit'
                  "
                >
                  {{ $route.query.view_no }}
                  <i class="la la-angle-right la-lg"></i>
                </span>
              </router-link>
            </small>
          </h2>
        </b-col>
        <b-col cols="8" md="8" xl="8" lg="8" sm="8" xs="8" class="text-right px-0">
          <template
            v-if="
              list.invoice_amount_detail.inv_status != 1 &&
                list.invoice_amount_detail.inv_status != 4 &&
                list.invoice_amount_detail.inv_status != 7
            "
          >
            <b-button
              variant="primary"
              class="mr-2"
              size="sm"
              v-if="
                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'create') &&
                  parseFloat(list.invoice_amount_detail.due_amount) > 0 &&
                  list.invoice_amount_detail.inv_status != 1
              "
              :to="{ name: 'InvoicePayment', params: { id: $route.params.id } }"
              >Record Payment</b-button
            >
            <b-button
              variant="primary"
              class="mr-2"
              size="sm"
              v-if="
                RoutePermission(false, '', 'invoice', 'invoice', 'writeoff') &&
                  parseFloat(list.invoice_amount_detail.due_amount) > 0 &&
                  list.invoice_amount_detail.inv_status != 1
              "
              v-b-modal.write-off
              >Write off</b-button
            >
            <b-button
              variant="primary"
              size="sm"
              @click="
                callWriteOff({
                  id: $route.params.id,
                  type: 'cancel',
                  writeoff_date: '',
                  writeoff_reason: '',
                })
              "
              v-if="
                RoutePermission(false, '', 'invoice', 'invoice', 'writeoff') &&
                  parseFloat(list.invoice_amount_detail.writeoff_amount) > 0
              "
              >Cancel Write off</b-button
            >
          </template>
          <b-button
            v-on:click="redirect = 0"
            v-if="
              list.invoice_amount_detail.inv_status == 1 &&
                RoutePermission(false, '', 'invoice', 'invoice', 'approve')
            "
            variant="primary"
            size="sm"
            class="mr-2"
            @click="
              handlingapprovingmodal({
                content: 'Are you sure you want to approve this ' + type + '?',
                title: 'Approve ' + type + '- ' + list.invoice_header_detail.inv_no,
                module: 'invoice/approveinvoice',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: '',
                isRoute: 'false',
                type: 'approve',
              })
            "
            >Approve</b-button
          >

          <b-button
            v-on:click="redirect = 1"
            variant="success"
            size="sm"
            class="mr-2"
            title="update"
            v-if="
              list.invoice_amount_detail.inv_status == 1 &&
                RoutePermission(false, '', 'invoice', 'invoice', 'approve') &&
                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'create')
            "
            @click="
              handlingapprovingmodal({
                content: 'Are you sure you want to approve this ' + type + '?',
                title: 'Approve ' + type + '- ' + list.invoice_header_detail.inv_no,
                module: 'invoice/approveinvoice',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: 'InvoicePayment',
                isRoute: 'true',
                type: 'approve',
              })
            "
            >Approve and Record Payment</b-button
          >
          <b-button
            variant="primary"
            size="sm"
            class="mr-2"
            v-if="RoutePermission(false, '', '', 'invoice', 'create')"
            :to="{
              name: 'InvoiceCreate',
              query: {
                type: list.invoice_header_detail.inv_type == 2 ? 'bill_of_supply' : 'invoice',
                page_from: 'view',
                old_id: $route.params.id,
              },
            }"
          >
            New {{ list.invoice_header_detail.inv_type == 2 ? "Bill of Supply" : "Invoice" }}
          </b-button>

          <b-button-group variant="light">
            <b-button
              v-if="
                list.invoice_header_detail.inv_status != '4' &&
                  RoutePermission(false, '', 'invoice', 'invoice', 'update')
              "
              size="sm"
              :to="{
                name: list.invoice_header_detail.is_export == 1 ? 'InvoiceUpdate' : 'InvoiceUpdate',
                params: { id: $route.params.id },
                query: {
                  type: list.invoice_header_detail.inv_type == 2 ? 'bill_of_supply' : 'invoice',
                  page_from: 'view',
                },
              }"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>

            <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
              <i class="la la-print la-lg"></i>
            </b-button>
            <b-dropdown
              right
              text="More"
              variant="light"
              size="sm"
              style="height:31px !important"
              v-if="
                (RoutePermission(false, '', 'invoice', 'invoice', 'delete') &&
                  list.invoice_amount_detail.inv_status < 2) ||
                  (RoutePermission(false, '', 'invoice', 'invoice', 'approvedaccess') &&
                    list.invoice_amount_detail.inv_status >= 2) ||
                  RoutePermission(false, '', 'invoice', 'invoice', 'email') ||
                  RoutePermission(false, '', 'invoice', 'recurringinvoice', 'create') ||
                  RoutePermission(false, '', 'invoice', 'invoice', 'create') ||
                  RoutePermission(false, '', 'invoice', 'credit', 'create') ||
                  ((RoutePermission(false, '', 'invoice', 'invoice', 'update') &&
                    list.invoice_header_detail.inv_status < 2) ||
                    (RoutePermission(false, '', 'invoice', 'invoice', 'approvedaccess') &&
                      list.invoice_header_detail.inv_status >= 2)) ||
                  RoutePermission(false, '', 'invoice', 'settings', 'templates') ||
                  RoutePermission(false, '', 'invoice', 'invoice', 'cancelled')
              "
            >
              <b-dropdown-item
                v-if="
                  (list.invoice_amount_detail.inv_status == 2 ||
                    list.invoice_amount_detail.inv_status == 1 ||
                    list.invoice_header_detail.grand_total == 0 ||
                    list.invoice_amount_detail.inv_status == 4) &&
                    list.invoice_header_detail.is_credits == 0 &&
                    ((RoutePermission(false, '', 'invoice', 'invoice', 'delete') &&
                      list.invoice_amount_detail.inv_status < 2) ||
                      (RoutePermission(false, '', 'invoice', 'invoice', 'approvedaccess') &&
                        list.invoice_amount_detail.inv_status >= 2))
                "
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to delete this ' + type + '?',
                    title: 'Delete ' + type + '- ' + list.invoice_header_detail.inv_no,
                    module: 'invoice/deleteinvoice',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: 'Invoice',
                    isRoute: 'true',
                    type: 'delete',
                    route_history: invoice_index_history,
                  })
                "
              >
                <i class="la la-trash la-lg mr-3"></i>Delete
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.invoice_header_detail.inv_status != '4' &&
                    RoutePermission(false, '', 'invoice', 'invoice', 'email')
                "
                :to="{
                  name: 'Email',
                  query: {
                    tns_type: 'Invoice',
                    tns_date: list.invoice_header_detail.created_date,
                    cus_id: list.invoice_header_detail.cus_id,
                    cus_name: list.invoice_header_detail.cus_name,
                    tns_no: list.invoice_header_detail.inv_no,
                    tns_mail: list.invoice_header_detail.cus_mail,
                    tns_currency: list.invoice_header_detail.cus_currency,
                    id: $route.params.id,
                    date_format: org_details.date_format,
                  },
                }"
              >
                <i class="la la-envelope la-lg mr-3"></i>Mail
              </b-dropdown-item>
              <b-dropdown-item
                v-if="RoutePermission(false, '', 'invoice', 'recurringinvoice', 'create')"
                :to="{
                  name: 'RecurringInvoiceCreate',
                  query: {
                    inv_id: $route.params.id,
                    type: list.invoice_header_detail.inv_type == '2' ? 'bill_of_supply' : 'invoice',
                  },
                }"
              >
                <i class="la la-retweet la-lg mr-3"></i>Make Recurring
              </b-dropdown-item>
              <b-dropdown-item
                v-if="RoutePermission(false, '', '', 'invoice', 'create')"
                :to="{
                  name: 'InvoiceCreate',
                  query: {
                    clone_id: $route.params.id,
                    type: list.invoice_header_detail.inv_type == '2' ? 'bill_of_supply' : 'invoice',
                    page_from: 'view',
                  },
                }"
              >
                <i class="la la-clone la-lg mr-3"></i>Clone
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.invoice_header_detail.inv_status != '4' &&
                    RoutePermission(false, '', 'invoice', 'credit', 'create')
                "
                @click="
                  list.invoice_header_detail.inv_status != 6
                    ? handlingapprovingmodal({
                        content:
                          'On creating a credit for this customer,the credit amount will be applied to this invoice.Are you sure you want to create credit note from this ' +
                          type +
                          '?',
                        title: 'Create Credit note',
                        module: 'invoice/allowcredits',
                        data: JSON.stringify({
                          id: $route.params.id,
                        }),
                        RoutePlace: '',
                        isRoute: 'false',
                        type: 'allowcredits',
                      })
                    : allow_credits()
                "
              >
                <i class="la la-file-o la-lg mr-3"></i>Create Credit note
              </b-dropdown-item>

              <b-dropdown-item
                v-if="
                  list.invoice_header_detail.inv_status != '4' &&
                    list.invoice_amount_detail.inv_status != 5 &&
                    list.invoice_amount_detail.inv_status != 6 &&
                    RoutePermission(false, '', 'invoice', 'invoice', 'cancelled')
                "
                v-on:click="redirect = 0"
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to cancel this ' + type + '?',
                    title: 'Cancel ' + type + '- ' + list.invoice_header_detail.inv_no,
                    module: 'invoice/cancelinvoice',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: '',
                    isRoute: 'false',
                    type: 'cancel',
                  })
                "
              >
                <i class="la la-ban la-lg mr-3"></i>Cancel
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.invoice_header_detail.inv_status == '4' &&
                    RoutePermission(false, '', 'invoice', 'invoice', 'cancelled')
                "
                v-on:click="redirect = 0"
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to open this ' + type + '?',
                    title: 'Convert to Open - ' + type + '- ' + list.invoice_header_detail.inv_no,
                    module: 'invoice/cancelinvoice',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: '',
                    isRoute: 'false',
                    type: 'cancel',
                  })
                "
              >
                <i class="la la-check la-lg mr-3"></i>Convert to Open
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.invoice_header_detail.inv_status != '4' &&
                    !list.invoice_header_detail.eway_bill_no &&
                    ((RoutePermission(false, '', 'invoice', 'invoice', 'update') &&
                      list.invoice_header_detail.inv_status < 2) ||
                      (RoutePermission(false, '', 'invoice', 'invoice', 'approvedaccess') &&
                        list.invoice_header_detail.inv_status >= 2))
                "
                v-b-modal.addeway
              >
                <i class="la la-truck la-lg mr-3"></i>Assosiate E-way bill Number
              </b-dropdown-item>
              <b-dropdown-item
                @click="showFullLayout"
                v-if="RoutePermission(false, '', 'invoice', 'settings', 'templates')"
              >
                <i class="la la-cog la-lg mr-3"></i>Customize Print
              </b-dropdown-item>
            </b-dropdown>

            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="invoice_index_history ? invoice_index_history : { name: 'Invoice' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <!-- 
      page first block
    -->
      <div class="view-block-tab" style="margin-left:-20px;margin-right:-20px;">
        <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
          <b-tab
            :title="list.invoice_header_detail.inv_type == 1 ? 'Invoice View' : 'Bill Of Supply'"
            :title-link-class="{ 'd-print-none': true }"
            class="p-0"
          >
            <div class="view-block d-flex d-print-none">
              <b-row class="w-100">
                <b-col cols="12" lg="12" md="12" class="py-3 d-flex px-2">
                  <div class="d-flex ml-3">
                    <div class="verticalLine5 pl-3 ml-4">
                      <h6>Total Amount</h6>
                      <span>
                        {{
                          getDetails(
                            $AppDetails.currency_details,
                            list.invoice_header_detail.cus_currency,
                            "currency_symbol"
                          ) +
                            " " +
                            parseFloat(list.invoice_header_detail.grand_total).toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                            )
                        }}
                      </span>
                    </div>
                    <div class="verticalLine4 pl-3 ml-5">
                      <h6>Due Amount</h6>
                      <span>
                        {{
                          getDetails(
                            $AppDetails.currency_details,
                            list.invoice_header_detail.cus_currency,
                            "currency_symbol"
                          ) +
                            " " +
                            parseFloat(list.invoice_amount_detail.due_amount).toLocaleString(
                              undefined,
                              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                            )
                        }}
                      </span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
            <!--  to show the available credit details -->
            <b-alert
              class="alert-transparent alert-shade d-print-none p-3 mx-mar my-2"
              :show="true"
              style="display:flex;"
              v-if="
                (list.invoice_amount_detail.inv_status == 2 ||
                  list.invoice_amount_detail.inv_status == 5) &&
                  (list.available_credits != '' || list.available_retainer != '')
              "
            >
              <!-- <div> -->
              <div class="float-left mr-3" v-if="list.available_credits != ''">
                <strong
                  >Credits Available (
                  {{
                    currency_symbol +
                      " " +
                      parseFloat(list.available_credits).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  }}
                  )</strong
                >
                <br />
                <span
                  class="apply text-link"
                  size="md"
                  v-on:click.stop="callavailablecreditsmodal()"
                  >Apply Now</span
                >
              </div>
              <div class="float-left" v-if="list.available_retainer != ''">
                <strong
                  >Deposits Available (
                  {{
                    currency_symbol +
                      " " +
                      parseFloat(list.available_retainer).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  }}
                  )</strong
                >
                <br />
                <span
                  class="apply text-link"
                  size="md"
                  v-on:click.stop="callavailableretainermodal()"
                  >Apply Now</span
                >
                <!-- </div> -->
              </div>
            </b-alert>

            <!--  invpoice main page -->

            <p
              class="text-link fw-semi-bold px-pad pt-2"
              v-b-modal.addeway
              v-if="
                list.invoice_header_detail.inv_status != '4' &&
                  !list.invoice_header_detail.eway_bill_no &&
                  list.invoice_header_detail.grand_total >= 50000 &&
                  parseFloat(
                    list.invoice_header_detail.grand_total -
                      list.invoice_header_detail.adjusted_amount
                  ) > 50000
              "
            >
              <span v-b-modal.addeway class="cursor_pointer">
                <i class="fa fa-truck"></i>
                Assosiate E-way bill Number
              </span>
            </p>
            <p class="px-pad pt-2" v-else-if="list.invoice_header_detail.eway_bill_no">
              e-way bill Number : {{ list.invoice_header_detail.eway_bill_no }}
              <span class="text-link">
                <i class="la la-edit la-lg cursor_pointer mb-2" v-b-modal.addeway></i>
              </span>
            </p>

            <StandardPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="inv_settings_details.print.templateId == 1"
            ></StandardPrint>
            <SpreadsheetPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="inv_settings_details.print.templateId == 2"
            ></SpreadsheetPrint>
            <RetailPrint
              class="p-4 custom-md-width"
              :printlabel="printlabel"
              :showprintlabel="showprintlabel"
              :list="list"
              v-if="inv_settings_details.print.templateId == 3"
            ></RetailPrint>
          </b-tab>
          <b-tab
            :title="'Payments (' + list.invoice_payment_details.length + ')'"
            :title-link-class="{ 'd-print-none': true }"
            v-if="list.invoice_payment_details.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <!-- <th class="text-left" width="20%" style="padding-left:22px !important">Payment</th> -->
                      <th>Payment Number</th>
                      <th>Date</th>
                      <th>Reference</th>
                      <th>Payment Mode</th>
                      <th class="text-right">Amount</th>
                      <th style="padding-right:22px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in list.invoice_payment_details"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <!-- <td class="text-left" style="padding-left:22px !important">{{ index+ 1 }}</td> -->
                      <td>
                        <template
                          v-if="
                            general_settings_details.preferences.modules.Payment &&
                              RoutePermission(false, '', 'invoice', 'paymentsreceived', 'index')
                          "
                          ><router-link
                            class="event-link theme-text-color"
                            :to="{ name: 'PaymentView', params: { id: item.pymnt_hdr_id } }"
                            >{{ item.pymnt_no }}</router-link
                          ></template
                        >
                        <template v-else>{{ item.pymnt_no }}</template>
                      </td>
                      <td>{{ getDateFormat(item.pymnt_date) }}</td>
                      <td>{{ item.ref_no }}</td>
                      <td>{{ item.method_name }}</td>
                      <td class="text-right">
                        {{
                          currency_symbol +
                            " " +
                            parseFloat(item.paid_amount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td style="width:50px;padding-right:22px">
                        <span v-show="showByIndex === index">
                          <b-dropdown
                            class="index-action-dropdown"
                            variant="link"
                            toggle-class="text-decoration-none"
                            text
                            size="sm"
                            :class="{ 'last-td-arrow': true }"
                            v-if="
                              RoutePermission(false, '', 'invoice', 'paymentsreceived', 'update') ||
                                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'delete')
                            "
                          >
                            <router-link
                              v-if="
                                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'update')
                              "
                              class="event-link dropdown-item"
                              :to="{
                                name: 'PaymentUpdate',
                                params: { id: item.pymnt_hdr_id },
                                query: { inv_id: $route.params.id },
                              }"
                              >Edit</router-link
                            >

                            <b-dropdown-item
                              @click="deletepaymentreason(index)"
                              v-if="
                                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'delete')
                              "
                              >Delete</b-dropdown-item
                            >
                          </b-dropdown>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab
            :title="'Credits Applied (' + list.invoice_credit_details.length + ')'"
            :title-link-class="{ 'd-print-none': true }"
            v-if="list.invoice_credit_details.length > 0"
            class="p-0 d-print-none"
          >
            <b-row style="max-width:1200px;" class="px-0">
              <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                <table
                  class="table table-bordered sales-table view-page-table last-child-border-none"
                >
                  <thead>
                    <tr>
                      <th width="20%" style="padding-left:22px !important">Date</th>
                      <th>CREDIT NOTE</th>

                      <th class="text-right">CREDITS APPLIED</th>
                      <th style="padding-right:15px !important"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in list.invoice_credit_details"
                      :key="item.id"
                      @mouseover="showByIndex = index"
                      @mouseout="showByIndex = null"
                    >
                      <td style="padding-left:22px !important">
                        {{ getDateFormat(item.pymnt_date) }}
                      </td>
                      <td class="text-link">
                        <router-link
                          v-if="
                            RoutePermission(false, '', 'bill', 'credit', 'update') &&
                              item.crdt_status != '6'
                          "
                          class="event-link ml-2"
                          :to="{
                            name: 'CreditUpdate',
                            params: { id: item.crdt_hdr_id },
                            query: { invoice_id: $route.params.id },
                          }"
                          >{{ item.crdt_no }}</router-link
                        >
                        <template v-else>{{ item.crdt_no }}</template>
                      </td>
                      <td class="text-right">
                        {{
                          currency_symbol +
                            " " +
                            parseFloat(item.paid_amount).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                        }}
                      </td>
                      <td style="width:50px;padding-right:15px">
                        <span v-show="showByIndex === index">
                          <i
                            class="glyphicon glyphicon-trash"
                            v-if="RoutePermission(false, '', 'bill', 'credit', 'delete')"
                            @click="deletecreditpayment(index)"
                          ></i>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <GlobalModal
          :content="content"
          :module="module"
          :title="title"
          :data="globalmodaldata"
          :isRoute="isRoute"
          :RoutePlace="RoutePlace"
          :type="globalmodaltype"
          :route_history="route_history"
          v-on:setSuccessHandlingModal="getSuccessHandlingModal"
        />
      </div>
      <!--  modal for adding confifugrationt table datas -->
      <CreditsAvailable
        v-if="RoutePermission(false, '', 'invoice', 'paymentsreceived', 'create')"
        :currency="currency_symbol"
        :field="creditDetails"
        @checkCustomer="checkCustomer"
        :place_of_supply="list.invoice_header_detail.place_of_supply"
      ></CreditsAvailable>
      <RetainerInvoiceAvailable
        @checkCustomer="checkCustomer"
        v-if="RoutePermission(false, '', 'invoice', 'paymentsreceived', 'create')"
        :currency="currency_symbol"
        :field="retainerDetails"
      ></RetainerInvoiceAvailable>
      <DeleteCreditRecord
        @recallRecord="recallRecord()"
        :CreditDeleteDetail="CreditDeleteDetail"
      ></DeleteCreditRecord>
      <DeletePaymentRecord
        @recallRecord="recallRecord()"
        :PaymentDeleteDetail="PaymentDeleteDetail"
      ></DeletePaymentRecord>
      <!--  print template activation -->

      <FlyOver :show_full_layout="show_full_layout">
        <template slot="page-content" v-if="show_full_layout">
          <h5 class="mb-4 fw-semi-bold text-left">
            Invoice Templates
            <span class="float-right pr-2">
              <i
                class="la la-close cursor_pointer fw-semi-bold pr-1"
                @click="show_full_layout = false"
              ></i>
            </span>
          </h5>
          <InvoicePrint :show_full_layout="show_full_layout" :path="$route.fullPath"></InvoicePrint>
        </template>
      </FlyOver>
      <LogRecord :message="logrecords"></LogRecord>
      <!-- write off modal -->
      <b-modal
        id="write-off"
        ref="writeoff"
        size="sm"
        title="Invoice Write Off"
        :ok-disabled="submitted"
        :ok-title-html="submitted == true ? loaderIcon + 'Write it off' : 'Write it off'"
        body-class="bg-white"
        cancel-variant="light"
        :no-close-on-backdrop="true"
        @ok.prevent="writeoffSubmit('writeoff')"
        @shown="
          writeoff = {
            id: $route.params.id,
            type: 'writeoff',
            writeoff_date: formatDate(new Date()),
            writeoff_reason: '',
          }
        "
        @hidden="(date_valid_message = ''), (submitted = false)"
      >
        <b-form data-vv-scope="writeoff">
          <b-row>
            <b-col xl="12" lg="12" md="12" xs="12" sm="12">
              <b-alert class="alert-transparent alert-danger" :show="date_valid_message != ''">
                <p class="text-danger m-0">{{ date_valid_message }}</p>
              </b-alert>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Write off date" label-for="data" label-class="required">
                <DatePicker
                  :format="$AppDetails.organization.date_format"
                  v-validate="'required'"
                  data-vv-name="date"
                  v-model.trim="field.bill_date"
                  lang="en"
                  input-class="form-control"
                  @change="selectDate"
                  style="width:100% !important;"
                  v-model="writeoff.writeoff_date"
                  :not-after="new Date()"
                >
                  <i class="fa fa-calendar text-dark" slot="calendar-icon" />
                </DatePicker>
                <span class="text-danger" v-if="error_show && errors.has('writeoff.date')">{{
                  errors.first("writeoff.date")
                }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Reason" label-for="reason" label-class="required">
                <b-textarea
                  v-validate="'required|max:255'"
                  data-vv-name="reason"
                  v-model="writeoff.writeoff_reason"
                ></b-textarea>
                <span class="text-danger" v-if="error_show && errors.has('writeoff.reason')">{{
                  errors.first("writeoff.reason")
                }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
      <EwayBill
        :eway_bill_no="list.invoice_header_detail.eway_bill_no"
        :id="list.invoice_header_detail.inv_hdr_id"
        @setewaybillno="ewayno()"
        :module_name="'invoice'"
      ></EwayBill>
    </template>
  </div>
</template>

<style scoped>
.saira-font {
  font-family: "Saira", sans-serif !important;
  font-weight: 500 !important;
}
.table.table-bordered.reports-table-border thead th {
  font-family: "Saira", sans-serif !important;
  font-weight: 500 !important;
}
.apply {
  cursor: pointer;
}
</style>
<script>
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
import FlyOver from "@/components/Layout/Flyover";
import getPageTitle from "@/utils/get-page-title"; // to set page title
import InvoicePrint from "@/pages/Settings/Invoice/Print";
import { mapState, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import PaymentForm from "./Payment";
import EwayBill from "@/components/Modal/EwayBill";
import DatePicker from "vue2-datepicker";
import store from "@/store/index";
import StandardPrint from "@/components/Form/Invoice/Print/Standard";
import SpreadsheetPrint from "@/components/Form/Invoice/Print/Spreadsheet";
import RetailPrint from "@/components/Form/Invoice/Print/Retail";
import CreditsAvailable from "@/components/Modal/InvoiceModal/CreditsAvailable"; // credits available modal\
import RetainerInvoiceAvailable from "@/components/Modal/InvoiceModal/RetainerInvoiceAvailable"; // credits available modal\
import DeleteCreditRecord from "@/components/Modal/InvoiceModal/DeleteCreditRecord"; // modal for deleting created credit used record
import DeletePaymentRecord from "@/components/Modal/InvoiceModal/DeletePaymentRecord"; // modal for deleting created credit used record
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import RecordNotFound from "@/pages/Error/RecordNotFound";
// Vue.use(converter);
export default {
  mixins: [notificationMixin, formatDate],
  name: "SalesCreate",
  components: {
    DatePicker,
    LogRecord,
    EwayBill,
    PaymentForm,
    CreditsAvailable,
    DeleteCreditRecord,
    DeletePaymentRecord,
    RetainerInvoiceAvailable,
    StandardPrint,
    SpreadsheetPrint,
    RetailPrint,
    FlyOver,
    RecordNotFound,
    InvoicePrint,
  },
  data() {
    return {
      error_show: false,
      logrecords: "",
      showByIndex: null,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      redirect: 0,
      show_full_layout: false,
      showprintlabel: false,
      printlabel: "",
      value: "",
      type: "",
      currency_symbol: "",
      show_notes: false,
      CreditDeleteDetail: {},
      creditDetails: {},
      retainerDetails: {},
      PaymentDeleteDetail: {},
      pymnt_del_id: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      writeoff: {},
      route_history: "",
      date_valid_message: "",
      field: {},
    };
  },
  methods: {
    // select date function
    selectDate(val) {
      this.writeoff.writeoff_date =
        val == "" || typeof val == "undefined" || val == null ? "" : this.formatDate(val);
    },
    writeoffSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.error_show = false;
          this.callWriteOff(this.writeoff);
        } else {
          this.error_show = true;
        }
      });
    },
    allow_credits() {
      var data = JSON.stringify({
        id: this.$route.params.id,
      });
      this.$store.dispatch("invoice/allowcredits", data).then(() => {
        this.$router.push({
          name: "CreditCreate",
          query: {
            invoice_id: this.$route.params.id,
          },
        });
      });
    },
    callWriteOff(data) {
      this.submitted = true;
      this.$store.dispatch("invoice/writeoffinvoice", data).then((response) => {
        if (this.status_code == 200) {
          this.date_valid_message = "";
          this.list.invoice_amount_detail.writeoff_amount = response.writeoff_amount;
          this.list.invoice_amount_detail.inv_status = response.inv_status;
          this.list.invoice_amount_detail.due_amount = response.due_amount;
          this.list.invoice_amount_detail.inv_status_name = response.inv_status_name;
          window.Messenger().post({
            extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
            message: response.status,
            type: "success",
            showCloseButton: true,
          });
          this.$refs.writeoff.hide();
        } else {
          this.date_valid_message = response.status;
        }
        this.submitted = false;
      });
    },
    getSuccessHandlingModal(ev) {
      if (
        this.status_code == 200 &&
        (this.globalmodaltype == "approve" || this.globalmodaltype == "cancel")
      ) {
        this.list.invoice_header_detail.inv_status = ev.data.status_id;
        this.list.invoice_header_detail.inv_status_name = ev.data.status_name;
        this.list.invoice_amount_detail.inv_status = ev.data.status_id;
        this.list.invoice_amount_detail.inv_status_name = ev.data.status_name;
      }
      if (this.globalmodaltype == "allowcredits") {
        if (ev.data.status == 1) {
          this.$router.push({
            name: "CreditCreate",
            query: {
              invoice_id: this.$route.params.id,
            },
          });
        } else {
          this.logrecords = ev.data.message;
          this.$root.$emit("bv::show::modal", "loglist");
        }
      }
    },
    //Customize overlay for Print
    async showFullLayout() {
      await store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Invoice",
        })
        .then(() => {
          this.show_full_layout = true;
        });
    },
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },

    // delete the selected recorc credti applied
    deletecreditpayment(index) {
      this.$root.$emit("bv::show::modal", "deletecreditpayment");
      this.CreditDeleteDetail = this.list.invoice_credit_details[index];
    },

    // get the reason how to delete the payment
    deletepaymentreason(index) {
      this.list.invoice_payment_details[index].inv_pymnt_id;
      store
        .dispatch(
          "invoice/deletepaymentreason",
          JSON.stringify({
            id: this.list.invoice_payment_details[index].inv_pymnt_id,
          })
        )
        .then(() => {
          if (this.status_code == 200) {
            this.$root.$emit("bv::show::modal", "paymentreason");
            this.PaymentDeleteDetail = this.list.invoice_payment_details[index];
            // this.$refs["paymentreason"].show();
          } else {
            window.Messenger().post({
              extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true,
            });
            store.dispatch("invoice/fetchList", parseInt(this.$route.params.id));
          }
        });
    },
    recallRecord() {
      store.dispatch("invoice/fetchList", parseInt(this.$route.params.id));
    },

    checkCustomer(ev) {
      window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message: ev.status_message,
        type: ev.status_type,
        showCloseButton: true,
      });
      this.$root.$emit("bv::hide::modal", "availableretainer");
      this.$root.$emit("bv::hide::modal", "availablecredits");
    },
    // get
    closeModal(id) {
      this.$refs[id].hide();
    },
    ewayno() {
      this.list.invoice_header_detail.eway_bill_no = this.eway_bill_no;
    },
    // call tag nodal
    callavailablecreditsmodal() {
      this.creditDetails = {
        id: this.list.invoice_header_detail.cus_id,
        due_amount: this.list.invoice_amount_detail.due_amount,
        inv_due_amount: this.list.invoice_amount_detail.due_amount,
      };
      this.$root.$emit("bv::show::modal", "availablecredits");
      EventBus.$emit("creditdetails");
    },
    // call tag nodal
    callavailableretainermodal() {
      this.retainerDetails = {
        id: this.list.invoice_header_detail.cus_id,
        due_amount: this.list.invoice_amount_detail.due_amount,
        inv_due_amount: this.list.invoice_amount_detail.due_amount,
      };
      this.$root.$emit("bv::show::modal", "availableretainer");
      EventBus.$emit("retainerinvoicedetails");
    },

    createFreshEventObject() {
      if (this.list.invoice_payment_details.length > 0) {
        this.payments = this.list.invoice_payment_details;
      } else {
        this.payments = [
          {
            inv_pymnt_id: "",
            pymnt_mthd: "",
            pymnt_date: this.list.invoice_header_detail.created_date,
            tns_no: "",
            paid_amount: "",
          },
        ];
      }
    },
    getTempProps() {
      this.field = this.$store.state.permission.print_settings_details["Invoice"].template_list;
    },
    async handlePrint() {
      await store.dispatch("invoice/fetchList", parseInt(this.$route.params.id));
      if (this.status_code == 200) {
        await this.getTempProps();
        document.title =
          this.list.invoice_header_detail.inv_no +
          " / " +
          this.list.invoice_header_detail.created_date;
        var id;
        var style;
        var size;
        if (this.inv_settings_details.print.templateId == 1) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-standard-portrait-page"
                : "a4-standard-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-standard-portrait-page"
                : "a5-standard-landscape-page"
              : "";
          style = "standard";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
        } else if (this.inv_settings_details.print.templateId == 2) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-spreadsheet-portrait-page"
                : "a4-spreadsheet-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-spreadsheet-portrait-page"
                : "a5-spreadsheet-landscape-page"
              : "";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
          style = "spreadsheet";
        } else {
          id =
            this.field.temp_prop.paper_size == 0
              ? "inch3-thermal-print-page"
              : "inch4-thermal-print-page";
          style = "retail";
          size = "";
        }

        var win;
        const element = document.getElementById(id);

        var printcontent = "";
        for (
          var i = 1;
          i <= this.general_settings_details.preferences.default_print_preference;
          i++
        ) {
          this.showprintlabel = await true;
          this.printlabel = await this.general_settings_details.preferences.document_copy_label[i];
          printcontent +=
            (await ' <div style="page-break-after:always">') + element.innerHTML + "</div>";
        }

        win = window.open("", "Title", "fullscreen=yes", "titlebar=yes", "scrollbars=yes");
        win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${
                  process.env.VUE_APP_INVOICE_API_URL
                }/css/print/${style}.css">
              </head>
              <body class="${id}">
              ${printcontent}
              </body>
            </html>
          `);

        if (navigator.userAgent.indexOf("Safari") != -1) {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
          }, 500);
          setTimeout(() => {
            win.close();
          }, 5000);
        } else {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
            win.close();
          }, 500);
        }
      }
    },
    handleComplete() {
      store.dispatch("invoice/updateComplete", this.$route.params.id).then(() => {
        store.dispatch("invoice/fetchList", parseInt(this.$route.params.id));
      });
    },
  },

  created() {
    this.getTempProps();
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.invoice_header_detail.cus_currency,
      "currency_symbol"
    );
    var data = {
      id: this.list.invoice_header_detail.cus_id,
      due_amount: this.list.invoice_header_detail.due_amount,
      inv_due_amount: this.list.invoice_header_detail.due_amount,
    };
    this.creditDetails = data;
    this.retainerDetails = data;
    this.mail_id = this.list.invoice_header_detail.cus_mail;
    this.type = this.list.invoice_header_detail.inv_type == 2 ? "Bill of supply" : "Invoice";
    if (this.list.invoice_payment_details.length > 0) {
      this.payments = this.list.invoice_payment_details;
    }
    this.initializationMessengerCode();

    document.title = getPageTitle(
      this.list.invoice_header_detail.inv_no + " | " + this.$route.meta.title
    );
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  beforeRouteEnter(to, from, next) {
    store.state.general.oldRoute = { name: from.name, params: from.params };
    store.dispatch("settings/fetchinvoicesettings", {
      stg_menu: "Invoice",
      stg_name: "inv_settings_details",
    });
    next();
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: (state) => state.invoice.list,
      email: (state) => state.invoice.email,
      oldRoute: (state) => state.general.oldRoute,
      eway_bill_no: (state) => state.invoice.eway_bill_no,
      code: (state) => state.invoice.code,
      status_code: (state) => state.invoice.status_code,
      status_message: (state) => state.invoice.status_message,
      status_type: (state) => state.invoice.status_type,
      invoice_index_history: (state) => state.invoice.invoice_index_history,
    }),
    print_template: {
      get() {
        return this.$store.state.general.print_option;
      },
      set(val) {
        this.$store.state.general.print_option = val;
      },
    },
    ...mapGetters(["general_settings_details", "org_details", "inv_settings_details"]),
  },
};
</script>
<style src="./Invoice.scss" lang="scss" scoped />
